import React from 'react';

const Article = () => {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M38 10V38H10V10H38ZM38 6H10C7.8 6 6 7.8 6 10V38C6 40.2 7.8 42 10 42H38C40.2 42 42 40.2 42 38V10C42 7.8 40.2 6 38 6Z'
        fill='#7CD1B8'
      />
      <path
        d='M28 34H14V30H28V34ZM34 26H14V22H34V26ZM34 18H14V14H34V18Z'
        fill='#7CD1B8'
      />
    </svg>
  );
};

export default Article;
